import isMaterialWarehouse, { isAssetsFactory } from '@/common/is-warehouse.js'

function getApiList() {
  return {
    // dmaker template
    '/dmaker/template/info': '/dmaker/template/info',
    '/dmaker/template/init-json': '/dmaker/template/init-json',
    '/dmaker/template/channel-list': '/dmaker/template/channel-list',
    '/dmaker/template/list-app': '/dmaker/template/list-app',

    // dmaker custom
    '/dmaker/custom/info': '/dmaker/custom/info',
    '/dmaker/custom/download-options': '/dmaker/custom/download-options',
    '/dmaker/custom/download': '/dmaker/custom/download',
    '/dmaker/custom/delete': '/dmaker/custom/delete',
    '/dmaker/custom/create': '/dmaker/custom/create',
    '/dmaker/custom/multi-list': '/dmaker/custom/multi-list',
    '/dmaker/custom/save': '/dmaker/custom/save',
    '/dmaker/custom/preview': '/dmaker/custom/preview',
    '/dmaker/custom/init-json': '/dmaker/custom/init-json',
    '/dmaker/custom/list': '/dmaker/custom/list',
    '/dmaker/custom/rename': '/dmaker/custom/rename',
    '/dmaker/custom/channel-list': '/dmaker/custom/channel-list',
    '/dmaker/custom/download-check': '/dmaker/custom/download-check',
    '/dmaker/custom/reset': '/dmaker/custom/reset',
    '/dmaker/custom/next-version': '/dmaker/custom/next-version',
    '/dmaker/custom/pack': '/dmaker/custom/pack',

    // dco
    '/dmaker/dco/create': '/dmaker/dco/create',
    '/dmaker/dco/delete': '/dmaker/dco/delete',
    '/dmaker/dco/info': '/dmaker/dco/info',
    '/dmaker/dco/list': '/dmaker/dco/list',
    '/dmaker/dco/save': '/dmaker/dco/save',
    '/dmaker/dco/detail': '/dmaker/dco/detail',
    '/dmaker/dco/build': '/dmaker/dco/build',
    '/openapi/dmaker/audio': '/open/dmaker/audio',
    '/openapi/dmaker/bin': '/open/dmaker/bin',
    '/openapi/dmaker/image': '/open/dmaker/image',
    '/gmaker/template/preview': '/gmaker/template/preview',
    '/gmaker/template-skin/list': '/gmaker/template-skin/list',

    // common
    '/common/language/list': '/common/language',
    '/common/config': '/common/config',
    '/upload/file': '/common/upload',
    '/common/download': '/common/download',
    '/creative/push/submit': '/creative/push/submit',
    '/creative/push/history': '/creative/push/history',
    '/login-ss': '/login-ss',
    '/res_store/tag/type-tags': '/common/dco-tags',
    '/report/dco/list': '/dmaker/dco/reports',
    '/common/font/list': '/common/font/list',
    '/common/video/capture': '/common/video/capture',
    '/common/font/crop': '/common/font/crop',
    '/common/bin/read': '/common/bin/read',
    '/common/web/capture': '/common/web/capture',
    '/common/translate': '/common/translate',
    '/ai/translate': '/ai/translate',
    '/common/asset/no-shelf-fonts': '/common/asset/no-shelf-fonts',
    '/ai/dvs': '/ai/dvs',
    '/common/asset/list': '/common/asset/list',
    '/common/asset-tag/assets': '/common/asset-tag/assets',
    '/common/asset-tag/assists': '/common/asset-tag/assists',
    '/common/asset/model-info': '/common/asset/model-info',
    '/asset/tag-group/list-all': '/ps/common/asset/tag-group',
  }
}

const apiList = getApiList()

export function getApiPath(path) {
  // 素材仓库直接返回 path
  if (isMaterialWarehouse() || isAssetsFactory()) {
    return path
  }

  const withApi = path.indexOf('/api') === 0
  const tempPath = path.replace('/api', '')

  // 对外系统接口如果配置了对应的接口映射，就返回其值，没有则返回传入的 path
  if (withApi) {
    return apiList[tempPath] ? `/api${apiList[tempPath]}` : path
  }
  return apiList[path] || path
}
